/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

document.addEventListener('variant:changed', function(event) {
  const newVariant = event.detail.variant;
  const previousVariant = event.detail.previousVariant;// Gives you access to the whole variant details
  const option1 = newVariant['option1'];
  const oldPrice = previousVariant['price'];
  const newPrice = newVariant['price'];
  const productMetaOptionAdded = document.querySelector('#optionAdded');
  const freeShipping = document.querySelector('#freeShipping');

        if (!newVariant) {
          productMetaOptionAdded.style.display = 'none';
        } else {
          if (previousVariant && previousVariant['option1'] === newVariant['option1']) {
            return; // The price do not have changed so let's return to avoid changing the DOM for nothing
          }
          
          productMetaOptionAdded.innerHTML = '';      
          productMetaOptionAdded.innerHTML += option1;
          productMetaOptionAdded.style.display = '';
          
          if ( previousVariant && newPrice >= 700000 ) {
            freeShipping.style.display = '';
          } else {
            freeShipping.style.display = 'none';
          }
        }
 });




  (function(d) {
    var config = {
      kitId: 'stl2kie',
      scriptTimeout: 3000,
      async: true
    },
    h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
  })(document);


// yotpo
(function e(){var e=document.createElement("script");e.type="text/javascript",e.async=true,e.src="//staticw2.yotpo.com/NduxGg7YqA9S50Z49zgnBpGEbKZpticmJyrikTdk/widget.js";var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t)})();

// drawer and hamburger

var Drawer = function(){
  var touch = false;
  var opened = false;
  var body = document.getElementsByTagName('body')[0];
  var hamburger = document.getElementById('hamburger');
  var overlay = document.getElementById('overlay');
  var drawerElement = document.getElementById('drawer');
  if(drawerElement){
      var drawerLinks = drawerElement.getElementsByTagName('a');
  }
  if(hamburger){
      hamburger.addEventListener('click',function(e){
          drawerTouch(e);
      })
      hamburger.addEventListener('touchstart',function(e){
          drawerTouch(e);
      })
  }
  if(drawerLinks){
      if( drawerLinks.length > 0 ){
          for(var i=0;i < drawerLinks.length; i ++){
              drawerLinks[i].addEventListener('click',function(){
                  setTimeout(function(){
                      drawerRemoveClass();
                  },300)
              })
              // drawerLinks[i].addEventListener('touchstart',function(){
              // 	drawerRemoveClass();
              // })
          }
      }
  }
  if(overlay){
      overlay.addEventListener('click',function(){
          drawerRemoveClass();
      })
  }
  var drawerTouch = function(e){
      switch (e.type) {
          case 'touchstart':
              drawerToggleClass();
              touch = true;
              return false;
          break;

          case 'click':
          if(!touch)
              drawerToggleClass();
              return false;
          break;
      }
  }
  var drawerToggleClass = function (){
      if(!opened){
          body.classList.add('drawer-opening');
          body.classList.add('drawer-opened');
          opened = true;

      }else{
          body.classList.remove('drawer-opening');
          body.classList.add('drawer-closing');
          setTimeout(function(){
              body.classList.remove('drawer-closing');
              body.classList.remove('drawer-opened');
              body.classList.remove('drawer-opening');

              opened = false;
          },300)
      }
  }
  var drawerRemoveClass = function (){
      body.classList.remove('drawer-opening');
      body.classList.add('drawer-closing');
      setTimeout(function(){
          body.classList.remove('drawer-closing');
          body.classList.remove('drawer-opened');
          body.classList.remove('drawer-opening');

          opened = false;
      },300)
  }
};
Drawer();

// 上スクロールでヘッダを表示する
// https://firstlayout.net/scroll-down-and-scroll-up-with-javascript/

// ieだとうまく表示されない　2019/05/10
( function() {
   var userAgent = window.navigator.userAgent.toLowerCase();
   var isIE = (userAgent.indexOf('msie') >= 0 || userAgent.indexOf('trident') >= 0);
    if(isIE) {
    //IE のときの挙動
      console.log(userAgent);
    } else {
    const target     = document.getElementById( 'shopify-section-header' ),
          target2     = document.getElementById('shopify-section-header-willstyle'),
          height     = target.offsetHeight + target2.offsetHeight ;
    let offset       =  0,
        lastPosition = 0,
        ticking      = false;
    
    function onScroll() {
        if( lastPosition > height ) {
            if( lastPosition > offset ) {
                target.classList.add( 'head-animation' );
            } else {
                target.classList.remove( 'head-animation' );
            }
            offset = lastPosition;
        }
    }
    
    window.addEventListener( 'scroll', function(e) {
        lastPosition = window.pageYOffset;
        
        if( !ticking ) {
            window.requestAnimationFrame( function() {
                onScroll( lastPosition );
                ticking = false;
            });
            ticking = true;
        }
    });
}
  
})();

(function() {
    var touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  })();

